import Home from '@/views/Home'
import Quotation from '@/views/Quotation'
import AskForHelp from '@/views/AskForHelp'
import BenefitByRFC from '@/views/BenefitByRFC'
import Benefit from '@/views/Benefit'
import BenefitA from '@/views/BenefitA'
import BenefitB from '@/views/BenefitB'
import BenefitC from '@/views/BenefitC'
import BenefitD from '@/views/BenefitD'
import PersonalInformation from '@/views/PersonalInformation'
import EconomicDependent from '@/views/EconomicDependent'
import AddApBeneficiary from '@/views/AddAPBeneficiary'
import Resume from '@/views/Resume'
import DigitalSignature from '@/views/DigitalSignature'
import SuccessfulProcess from "@/components/SuccessfulProcess";
import CaptureFolio from '@/views/CaptureFolio'
import NotFound from '@/views/NotFound'
import CargaIdentificacion from '@/views/CargaIdentificacion'
import Login from '@/views/Login'
import DigitalSalesReport from '@/views/DigitalSalesReport'
import DigitalSale from '@/views/DigitalSale'

import {createRouter, createWebHistory} from 'vue-router'


const router = createRouter({
    'history': createWebHistory(),
    routes: [
        {
            path: '/home/:reference/:id?',
            name: 'reference',
            component: Home,
        },
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/quotation',
            name: 'quotation',
            component: Quotation
        },
        {
            path: '/ask-for-help/',
            name: 'ask-for-help',
            component: AskForHelp
        },
        {
            path: '/benefit',
            name: 'benefit',
            component: Benefit
        },
        {
            path: '/benefitByReference',
            name: 'benefitByReference',
            component: BenefitByRFC
        },
        {
            path: '/benefit-a',
            name: 'benefit-a',
            component: BenefitA
        },
        {
            path: '/benefit-b',
            name: 'benefit-b',
            component: BenefitB
        },
        {
            path: '/benefit-c',
            name: 'benefit-c',
            component: BenefitC
        },
        {
            path: '/benefit-d',
            name: 'benefit-d',
            component: BenefitD
        },
        {
            path: '/personal-information',
            name: 'personal-information',
            component: PersonalInformation
        },
        {
            path: '/economic-dependent',
            name: 'economic-dependent',
            component: EconomicDependent
        },
        {
            path: '/add-ap-beneficiary',
            name: 'add-ap-beneficiary',
            component: AddApBeneficiary
        },
        {
            path: '/carga-identificacion',
            name: 'carga-identificacion',
            component: CargaIdentificacion
        },
        {
            path: '/capture-folio',
            name: 'capture-folio',
            component: CaptureFolio
        },
        {
            path: '/resume',
            name: 'resume',
            component: Resume
        },
        {
            path: '/digital-signature',
            name: 'digital-signature',
            component: DigitalSignature
        },
        {
            path: '/successful-process',
            name: 'successful-process',
            component: SuccessfulProcess
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/digital-sales-report',
            name: 'digital-sales-report',
            component: DigitalSalesReport
        },
        {
            path: '/digital-sale/:digital_insurance_id',
            name: 'digital-sale',
            component: DigitalSale
        },
        {
            path: '/*',
            name: 'not-found',
            component: NotFound
        }

    ],
    // eslint-disable-next-line no-unused-vars
    scrollBehavior (to, from, savedPosition) {
        // return desired position
        return { x: 0, y: 0 }

      }
    })

export default router;
